import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import ProtectedRoute from "./routes/ProtectedRoute";
import HomePage from "./pages/HomePage";
import ProfilePage from "./pages/ProfilePage";
import CalculationsPage from "./pages/CalculationsPage";
import AddUserPage from "./pages/AddUserPage";
import SettingsPage from "./pages/SettingsPage";
import MonthlySTDCalculationsPage from "./pages/standard_forecast/MonthlySTDCalculationsPage";
// Forecast Pro modules disabled
// import MonthlyFPCalculationsPage from "./pages/forecast_pro/MonthlyFPCalculationsPage";
// import WeeklyFPCalculationsPage from "./pages/forecast_pro/WeeklyFPCalculationsPage";
import WeeklySTDCalculationsPage from "./pages/standard_forecast/WeeklySTDCalculationsPage";
import CalculationResultPage from "./pages/CalculationResultPage";
import ErrorPage from "./pages/ErrorPage";
// import FpCalculationResultPage from "./pages/FPCalculationResultPage";
import InstructionsPage from "./pages/instructions/InstructionsPage";
import {LanguageProvider} from "./components/LanguageContext";

const ApplicationRoutes = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="" index element={<LoginPage/>}/>
                <Route path="/*" element={<ProtectedRoute/>}>
                    <Route path="home" element={<HomePage/>}/>
                    <Route path="profile" element={<ProfilePage/>}/>
                    <Route path="settings" element={<SettingsPage/>}/>
                    <Route path="calculations" element={<CalculationsPage/>}/>
                    <Route path="add-user" element={<AddUserPage/>}/>

                    <Route path="std/monthly/calculations" element={<MonthlySTDCalculationsPage/>}/>
                    <Route path="std/weekly/calculations" element={<WeeklySTDCalculationsPage/>}/>

                    {/* Forecast Pro modules disabled */}
                    {/*
                    <Route path="fp/monthly/calculations" element={<MonthlyFPCalculationsPage/>}/>
                    <Route path="fp/weekly/calculations" element={<WeeklyFPCalculationsPage/>}/>
                    <Route path="fp-calculation/:id" element={<FpCalculationResultPage/>}/>
                    */}

                    <Route path="calculation/:id" element={<CalculationResultPage/>}/>

                    <Route path="instructions" element={<InstructionsPage/>}/>

                    <Route path="*" element={<ErrorPage/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

function App() {
    const queryClient = new QueryClient();
    return (
        <QueryClientProvider client={queryClient}>
            <LanguageProvider>
                <ApplicationRoutes/>
            </LanguageProvider>
        </QueryClientProvider>
    );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App/>);
